<template>
    <div class="toggle-container box" v-bind:id="'accordion' + id_pax">
        <!-- >>> Services for 'Booking' -->
        <template v-if="modulo === 'booking'">
            <div class="tab-container full-width-style white-bg">
                <!-- >>> Srvcs-Tabs-Tabs -->
                <ul class="tabs">
                    <li v-bind:class="{ active: getActiveTabBooking('MEAL') }">
                        <a v-bind:href="'#first-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsMealExists"><i class="soap-icon-breakfast circle"></i>{{ cat_meals[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTabBooking('SERVICE') }">
                        <a v-bind:href="'#second-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsServiceExists"><i class="soap-icon-family circle"></i>{{ cat_service[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTabBooking('PETS') }">
                        <a v-bind:href="'#third-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsPetsExists"><i class="soap-icon-dog circle"></i>{{ cat_pets[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTabBooking('SPORTBAG') }">
                        <a v-bind:href="'#fourth-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsSportbagExists"><i class="soap-icon-playplace circle"></i>{{ cat_sportbag[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTabBooking('BAGGAGE') }">
                        <a v-bind:href="'#fifth-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsBaggageExists"><i class="soap-icon-suitcase circle"></i>{{ cat_baggage[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTabBooking('MEDICAL') }">
                        <a v-bind:href="'#sixth-tab_' + id_pax" data-toggle="tab" v-if="getBookingSrvcsMedicalExists"><i class="soap-icon-baggage-4 circle"></i>{{ cat_medical[getCurrentLocale] }}</a>
                    </li>
                </ul>
                <!-- <<< Srvcs-Tabs-Tabs -->


                <!-- >>> Srvcs-Tabs-Content -->
                <div class="tab-content">
                    <!-- >>> SrvcsCat: 'Meals' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('MEAL'), active: getActiveTabBooking('MEAL') }" v-bind:id="'first-tab_' + id_pax" v-if="getBookingSrvcsMealExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_meals[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_meals'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsMeals" v-bind:key="srvcs.id">
                                <!-- >>> Title -->
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_meals'"> >>> {{ srvcs.description }} </a>
                                </h4>
                                <!-- <<< Title -->

                                <!-- >>> Content -->
                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-breakfast circle" srvcs_image="/res/images/services/meals/meals_1.png" srvcs_type="MEAL" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                                <!-- <<< Content -->
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Meals' -->


                    <!-- >>> SrvcsCat: 'Service' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('SERVICE'), active: getActiveTabBooking('SERVICE') }" v-bind:id="'second-tab_' + id_pax" v-if="getBookingSrvcsServiceExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_service[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_service'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsService" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax+ '_service'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-family circle" srvcs_image="/res/images/services/services/services_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Service' -->


                    <!-- >>> SrvcsCat: 'Pets' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('PETS'), active: getActiveTabBooking('PETS') }" v-bind:id="'third-tab_' + id_pax" v-if="getBookingSrvcsPetsExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_pets[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_pets'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsPets" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_pets'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-dog circle" srvcs_image="/res/images/services/pets/pets_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Pets' -->


                    <!-- >>> SrvcsCat: 'Sportbag' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('SPORTBAG'), active: getActiveTabBooking('SPORTBAG') }" v-bind:id="'fourth-tab_' + id_pax" v-if="getBookingSrvcsSportbagExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_sportbag[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_sportbag'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsSportbag" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_sportbag'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-playplace circle" srvcs_image="/res/images/services/sportequipment/sportequipment_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Sportbag' -->


                    <!-- >>> SrvcsCat: 'Baggage' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('BAGGAGE'), active: getActiveTabBooking('BAGGAGE') }" v-bind:id="'fifth-tab_' + id_pax" v-if="getBookingSrvcsBaggageExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_baggage[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_baggage'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsBaggage" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_baggage'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-suitcase circle" srvcs_image="/res/images/services/baggage/baggage_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Baggage' -->


                    <!-- >>> SrvcsCat: 'Medical' -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTabBooking('MEDICAL'), active: getActiveTabBooking('MEDICAL') }" v-bind:id="'sixth-tab_' + id_pax" v-if="getBookingSrvcsMedicalExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_medical[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_medical'">
                            <div class="panel style2" v-for="(srvcs, index) in getBookingPassengersSrvcsMedical" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_medical'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-baggage-4 circle" srvcs_image="/res/images/services/medical/medical_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Medical' -->
                </div>
                <!-- >>> Srvcs-Tabs-Content -->
            </div>
        </template>
        <!-- <<< Services for 'Booking' -->


        <!-- >>> Services for 'Services' -->
        <template v-if="modulo === 'services'">
            <div class="tab-container full-width-style white-bg">
                <!-- >>> Srvcs-Tabs-Tabs -->
                <ul class="tabs">
                    <li v-bind:class="{ active: getActiveTab('MEAL') }">
                        <a v-bind:href="'#first-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsMealExists"><i class="soap-icon-breakfast circle"></i>{{ cat_meals[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTab('SERVICE') }">
                        <a v-bind:href="'#second-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsServiceExists"><i class="soap-icon-family circle"></i>{{ cat_service[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTab('PETS') }">
                        <a v-bind:href="'#third-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsPetsExists"><i class="soap-icon-dog circle"></i>{{ cat_pets[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTab('SPORTBAG') }">
                        <a v-bind:href="'#fourth-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsSportbagExists"><i class="soap-icon-playplace circle"></i>{{ cat_sportbag[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTab('BAGGAGE') }">
                        <a v-bind:href="'#fifth-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsBaggageExists"><i class="soap-icon-suitcase circle"></i>{{ cat_baggage[getCurrentLocale] }}</a>
                    </li>
                    <li v-bind:class="{ active: getActiveTab('MEDICAL') }">
                        <a v-bind:href="'#sixth-tab_' + id_pax" data-toggle="tab" v-if="getServicesSrvcsMedicalExists"><i class="soap-icon-suitcase circle"></i>{{ cat_medical[getCurrentLocale] }}</a>
                    </li>
                </ul>
                <!-- <<< Srvcs-Tabs-Tabs -->


                <!-- >>> Srvcs-Tabs-Content -->
                <div class="tab-content">
                    <!-- >>> SrvcsCat: 'Meals' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('MEAL'), active: getActiveTab('MEAL') }" v-bind:id="'first-tab_' + id_pax" v-if="getServicesSrvcsMealExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_meals[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_meals'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'meal' })" v-bind:key="srvcs.id">
                                <!-- >>> Title -->
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_meals'"> >>> {{ srvcs.description }} </a>
                                </h4>
                                <!-- <<< Title -->

                                <!-- >>> Content -->
                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-breakfast circle" srvcs_image="/res/images/services/meals/meals_1.png" srvcs_type="MEAL" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                                <!-- <<< Content -->
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Meals' ('Services') -->


                    <!-- >>> SrvcsCat: 'Service' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('SERVICE'), active: getActiveTab('SERVICE') }" v-bind:id="'second-tab_' + id_pax" v-if="getServicesSrvcsServiceExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_service[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_service'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'service' })" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax+ '_service'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-family circle" srvcs_image="/res/images/services/services/services_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Service' ('Services') -->


                    <!-- >>> SrvcsCat: 'Pets' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('PETS'), active: getActiveTab('PETS') }" v-bind:id="'third-tab_' + id_pax" v-if="getServicesSrvcsPetsExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_pets[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_pets'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'pets' })" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_pets'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-dog circle" srvcs_image="/res/images/services/pets/pets_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Pets' ('Services') -->


                    <!-- >>> SrvcsCat: 'Sportbag' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('SPORTBAG'), active: getActiveTab('SPORTBAG') }" v-bind:id="'fourth-tab_' + id_pax" v-if="getServicesSrvcsSportbagExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_sportbag[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_sportbag'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'sportbag' })" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_sportbag'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-playplace circle" srvcs_image="/res/images/services/sportequipment/sportequipment_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Sportbag' ('Services') -->


                    <!-- >>> SrvcsCat: 'Baggage' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('BAGGAGE'), active: getActiveTab('BAGGAGE') }" v-bind:id="'fifth-tab_' + id_pax" v-if="getServicesSrvcsBaggageExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_baggage[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_baggage'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'baggage' })" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_baggage'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-suitcase circle" srvcs_image="/res/images/services/baggage/baggage_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Baggage' ('Services') -->


                    <!-- >>> SrvcsCat: 'Medical' ('Services') -->
                    <div class="tab-pane fade" v-bind:class="{ in: getActiveTab('MEDICAL'), active: getActiveTab('MEDICAL') }" v-bind:id="'sixth-tab_' + id_pax" v-if="getServicesSrvcsMedicalExists">
                        <h3 class="tab-content-title">{{ category[getCurrentLocale] }}: '{{ cat_medical[getCurrentLocale] }}'</h3>
                        <div class="toggle-container box" v-bind:id="'accordion' + id_pax + '_medical'">
                            <div class="panel style2" v-for="(srvcs, index) in getServicesPassengersSrvcsOfType({ type: 'medical' })" v-bind:key="srvcs.id">
                                <h4 class="panel-title">
                                    <a v-bind:class="{ collapsed: index !== 0 }" v-bind:href="'#acc1' + id_pax + '_' + srvcs.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + id_pax + '_medical'"> >>> {{ srvcs.description }} </a>
                                </h4>

                                <div class="panel-collapse collapse" v-bind:class="{ in: index === 0 }" v-bind:id="'acc1' + id_pax + '_' + srvcs.id">
                                    <!-- >>> VueCmp - 'sdr-service-details', 'Services Details' -->
                                    <sdr-service-details v-bind:id_pax="id_pax" v-bind:srvcs="srvcs" soap_icon="soap-icon-baggage-4 circle" srvcs_image="/res/images/services/medical/medical_1.png" :modulo="modulo"></sdr-service-details>
                                    <!-- <<< VueCmp - 'sdr-service-details', 'Services Details' -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< SrvcsCat: 'Baggage' ('Services') -->
                </div>
                <!-- >>> Srvcs-Tabs-Content -->
            </div>
        </template>
        <!-- <<< Services for 'Booking' -->
    </div>
</template>

<script>
    import ServiceDetails from '../../../booking/passengers/services/ServiceDetails.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['id_pax', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-service-details': ServiceDetails,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                cat_service: {
                    en: 'Service',
                    de: 'Service',
                },
                cat_meals: {
                    en: 'Meals',
                    de: 'Essen',
                },
                cat_pets: {
                    en: 'Pets',
                    de: 'Tiere',
                },
                cat_pets: {
                    en: 'Pets',
                    de: 'Tiere',
                },
                cat_sportbag: {
                    en: 'Sportequip.',
                    de: 'Sportequip.',
                },
                cat_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck',
                },
                cat_medical: {
                    en: 'Medical',
                    de: 'Medizinisch',
                },
                category: {
                    en: 'Your Services in Category',
                    de: 'Ihre Services in Kategorie',
                },
                chooseyourservices: {
                    en: 'Select your services',
                    de: 'Wählen Sie ihre Services aus',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getBookingSrvcsMealExists',
                'getBookingSrvcsServiceExists',
                'getBookingSrvcsPetsExists',
                'getBookingSrvcsSportbagExists',
                'getBookingSrvcsBaggageExists',
                'getBookingSrvcsMedicalExists',
                // >>> --------------------------
                'getBookingPassengersSrvcsService',
                'getBookingPassengersSrvcsMeals',
                'getBookingPassengersSrvcsPets',
                'getBookingPassengersSrvcsSportbag',
                'getBookingPassengersSrvcsBaggage',
                'getBookingPassengersSrvcsMedical',
                // >>> --------------------------
                'getServicesSrvcsMealExists', // (same for 'Services')
                'getServicesSrvcsServiceExists', // (same for 'Services')
                'getServicesSrvcsPetsExists', // (same for 'Services')
                'getServicesSrvcsSportbagExists', // (same for 'Services')
                'getServicesSrvcsBaggageExists', // (same for 'Services')
                'getServicesSrvcsMedicalExists', // (same for 'Services')
                // >>> --------------------------
                'getServicesPassengersSrvcsOfType', // (same for 'Services') (universal)
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getActiveTabBooking()
            *
            * Desc: Which Tab is active? (Booking)
            * Note:
            *
            */
            getActiveTabBooking(srvcscat) {

                var me = this,
                    doesMealExist = this.getBookingSrvcsMealExists,
                    doesServiceExist = this.getBookingSrvcsServiceExists,
                    doesPetsExist = this.getBookingSrvcsPetsExists,
                    doesSportbagExist = this.getBookingSrvcsSportbagExists,
                    doesBaggageExist = this.getBookingSrvcsBaggageExists,
                    shouldBeActiveTab = false;


                me.$toc('>>> booking/passengers/services/Services.vue >>> getActiveTabBooking');
                if (srvcscat === 'MEAL' && doesMealExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'SERVICE' && doesServiceExist && !doesMealExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'PETS' && doesPetsExist && !doesMealExist  && !doesServiceExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'SPORTBAG' && doesSportbagExist && !doesMealExist  && !doesServiceExist && !doesPetsExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'BAGGAGE' && doesBaggageExist && !doesMealExist  && !doesServiceExist && !doesPetsExist  && !doesSportbagExist) {
                    shouldBeActiveTab = true;
                }


                return shouldBeActiveTab;

            }, // eof getActiveTabBooking()

            /*******************************************************************
            * getActiveTab()
            *
            * Desc: Which Tab is active? (Services)
            * Note:
            *
            */
            getActiveTab(srvcscat) {

                var me = this,
                    doesMealExist = this.getServicesSrvcsMealExists,
                    doesServiceExist = this.getServicesSrvcsServiceExists,
                    doesPetsExist = this.getServicesSrvcsPetsExists,
                    doesSportbagExist = this.getServicesSrvcsSportbagExists,
                    doesBaggageExist = this.getServicesSrvcsBaggageExists,
                    shouldBeActiveTab = false;


                // me.$toc('>>> booking/passengers/services/Services.vue >>> getActiveTab');
                if (srvcscat === 'MEAL' && doesMealExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'SERVICE' && doesServiceExist && !doesMealExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'PETS' && doesPetsExist && !doesMealExist  && !doesServiceExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'SPORTBAG' && doesSportbagExist && !doesMealExist  && !doesServiceExist && !doesPetsExist) {
                    shouldBeActiveTab = true;
                }
                if (srvcscat === 'BAGGAGE' && doesBaggageExist && !doesMealExist  && !doesServiceExist && !doesPetsExist  && !doesSportbagExist) {
                    shouldBeActiveTab = true;
                }


                return shouldBeActiveTab;

            }, // eof getActiveTab()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .toggle-container .panel.style2 .panel-title > a.collapsed:after {
        content: "\f067";
        color: #fff;
        background: #3b79b0;
    }
    .toggle-container .panel.style2 .panel-title > a {
        xpadding-top: 40px;
    }
    .tab-container.full-width-style .tab-content .tab-content-title {
        padding-left: 20px;
        padding-bottom: 14px;
    }
    .price {
        float: none;
        padding-right: 0px;
        padding-top: 20px;
        text-transform: none;
    }
    .tab-container.full-width-style .tab-content .tab-content-title {
        color: #3b79b0;
    }
    .tab-container .tab-content .tab-pane {
        padding-top: 0px;
    }
    .toggle-container .panel.style2 .panel-title {
        margin-top: 5px;
    }
    .toggle-container .panel.style2 .panel-title > a.collapsed:hover {
        color: #3b79b0;
    }
    .toggle-container .panel.style2 .panel-title > a {
        color: #303D50;
    }
    .box {
        margin-bottom: 0px;
    }

    .alert.alert-help {
        background: #74d9f9;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h3 {
            font-size: 1.3333em;
        }


        .tab-container.full-width-style ul.tabs li a {
            font-size: 1.0em;
        }

        .tab-container .tab-content .tab-pane {
            padding: 1px;
        }


        .toggle-container .panel.style2 .panel-content {
            padding-top: 0px;
            padding-right: 1px;
            padding-bottom: 30px;
            padding-left: 3px;
        }

        .toggle-container .panel h4.panel-title {
            font-size: 1.2em;
        }

        .toggle-container .panel.style2 .panel-title > a:after {
            right: 1px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/booking/passengers/services/Services.vue